import React, {FC} from 'react';
import {MissionBadgeType} from '../../../types/missions';
import {BICTranslations} from '../../../ui/CodBankData/components/FormContent';
import {
  BankDetailsTranslationContext,
  BankDetailsTranslationContextObject,
} from '../../../ui/CodBankData/context/CodBankDataTranslation.context';
import useBankDataState from '../../../ui/CodBankData/hooks/useBankDataState';
import {AccountAreaNavigationProps} from '../../../ui/Navigation/AccountAreaNavigation/AccountAreaNavigation';
import {
  ClientSideNavigationProvider,
  RouterNavigateClientFactory,
} from '../../../ui/Navigation/ClientSideLink/ClientSideLink';
import BankDataPageUI from './BankDataPageUI.desktop';
import BankDataPageTranslationContext, {
  BankDataPageTranslations,
} from './context/TranslationProvider';

export interface BankDataPageProps extends AccountAreaNavigationProps {
  bankDataPageTranslations: BankDataPageTranslations;
  bankDetailsTranslations: BankDetailsTranslationContextObject;
  bicTranslations: BICTranslations;
  navigateClient: RouterNavigateClientFactory;
  MissionBadge: MissionBadgeType;
}

const BankDataPage: FC<BankDataPageProps> = function BankDataPage({
  bankDataPageTranslations,
  bankDetailsTranslations,
  bicTranslations,
  navigateClient,
  MissionBadge,
  ...navigationProps
}) {
  const {
    codPaymentInformation,
    updateOrCreateBankInformation,
    fetchCodPaymentInformation,
    loadingCache,
  } = useBankDataState(navigationProps.locale, true);

  React.useEffect(() => {
    fetchCodPaymentInformation();
  }, [fetchCodPaymentInformation]);

  return (
    <ClientSideNavigationProvider navigateClient={navigateClient}>
      <BankDataPageTranslationContext.Provider value={bankDataPageTranslations}>
        <BankDetailsTranslationContext.Provider value={bankDetailsTranslations}>
          <BankDataPageUI
            updateOrCreateBankInformation={updateOrCreateBankInformation}
            codPaymentInformation={codPaymentInformation}
            loading={loadingCache}
            bicTranslations={bicTranslations}
            MissionBadge={MissionBadge}
            {...navigationProps}
          />
        </BankDetailsTranslationContext.Provider>
      </BankDataPageTranslationContext.Provider>
    </ClientSideNavigationProvider>
  );
};

export default BankDataPage;
